import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [NgIf],
})
export class ToastComponent {
  @Input() message = '';
  @Input() action?: string;
  @Output() actionClick = new EventEmitter<void>();
}
